import { action, makeAutoObservable, observable } from "mobx";

class EmployeeBreadcrumbStore {
    employeeName : string = "";
    constructor() {
        makeAutoObservable(this, {
            employeeName: observable,
            update: action,
        });
    }

    public update(responseName: string) {
        this.employeeName = responseName
    }
}

export default new EmployeeBreadcrumbStore();